
const ua = navigator.userAgent;


const isUniWeb = /uni-app/i.test(ua) ;
const isWxmp = ua.toLowerCase().indexOf('miniprogram') > -1;
let nb = require('./H5/index.js');
if (isUniWeb) {
  nb = require('./uni-H5/index.js');
} else if (isWxmp) {
  nb = require('./uni-wx/index.js');
}

export default nb
